import { useRoutes, Outlet } from 'react-router-dom';
import { lazy } from 'react';
import CompactLayout from 'src/layouts/compact';
import { mainRoutes, HomePage, OrderPage,OrderSummary,TransactionSuccess } from './main';
import { dashboardRoutes } from './dashboard';
import AuthGuard from 'src/auth/guard/auth-guard';
import useSessionStore from 'src/store/useSessionStore';
import SessionExpiredModal from 'src/pages/session-expired';

const SweepstakeRouter = () => {
  const location = window.location;
  const queryParams = new URLSearchParams(location.search);

  if (queryParams.has('order-summary')) {
    return <OrderSummary />;
  }
  else if (queryParams.has('transaction-success')) {
    return <TransactionSuccess />;
  }
  return <OrderPage />;
};

const SessionGuard = ({ children }) => {
  const isSessionExpired = useSessionStore((state) => state.isSessionExpired);

  if (isSessionExpired) {
    return (
      <>
        {children}
        <SessionExpiredModal isOpen={true} />
      </>
    );
  }

  return children;
};

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <SessionGuard>
          <AuthGuard>
            <HomePage />
          </AuthGuard>
        </SessionGuard>
      ),
    },

    {
      path: '/sweepstake.aspx',
      element: (
        <SessionGuard>
          <AuthGuard requireAuth={false}>
            <CompactLayout>
              <SweepstakeRouter />
            </CompactLayout>
          </AuthGuard>
        </SessionGuard>
      ),
    },
    ...dashboardRoutes.map(route => ({
      ...route,
      element: <SessionGuard>{route.element}</SessionGuard>
    })),
    ...mainRoutes.map(route => ({
      ...route,
      element: (
        <SessionGuard>
          {route.element}
        </SessionGuard>
      ),
      ...(route.children && {
        children: route.children.map(childRoute => ({
          ...childRoute,
          element: <SessionGuard>{childRoute.element}</SessionGuard>
        }))
      })
    })),
  ]);
}